import api_article from '../../../api/_article'
import api_medicament from '../../../api/_medicament'

export default {
    getAllArticles() {
        return new Promise((resolve, reject) => {
            api_article.allArticles().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    listeMedicamentsOrdonne() {
        return new Promise((resolve, reject) => {
            api_medicament.listeMedicamentsOrdonne().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapStock(data) {
        return new Promise((resolve, reject) => {
            api_article.getRecapStock(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeArticeACommander() {
        return new Promise((resolve, reject) => {
            api_article.getListeArticeACommander().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }
}